/**
 * Utilitário para gerar links de confirmação de agendamento
 * Esses links contêm tokens temporários que expiram após um período
 */

/**
 * Gera a URL de confirmação de agendamento
 * @param scheduleId - ID do agendamento
 * @param token - Token temporário gerado pelo backend
 * @param baseUrl - URL base da aplicação (padrão: URL atual)
 * @returns URL completa para confirmação
 */
export const generateScheduleConfirmationUrl = (
  scheduleId: string,
  token: string,
  baseUrl?: string,
): string => {
  const base = baseUrl || window.location.origin;
  // Tentativa de obter tenant a partir do sessionStorage (mesma chave usada pelo api client)
  const tenant = sessionStorage.getItem('@Sigeclin:clinic');

  // Se houver tenant, inclua-o como primeiro segmento de caminho: /{tenant}/confirm-appointment/...
  if (tenant) {
    return `${base}/${tenant}/confirm-appointment/${scheduleId}/${token}`;
  }

  return `${base}/confirm-appointment/${scheduleId}/${token}`;
};

/**
 * Formata a URL para ser enviada via email ou SMS
 * @param scheduleId - ID do agendamento
 * @param token - Token temporário
 * @returns Objeto com URL e versão encurtada (se necessário)
 */
export const formatScheduleConfirmationLink = (
  scheduleId: string,
  token: string,
) => {
  const fullUrl = generateScheduleConfirmationUrl(scheduleId, token);
  return {
    fullUrl,
    shortUrl: fullUrl.substring(0, 100) + (fullUrl.length > 100 ? '...' : ''),
    markdown: `[Confirmar Agendamento](${fullUrl})`,
    html: `<a href="${fullUrl}">Confirmar Agendamento</a>`,
  };
};

/**
 * Extrai parâmetros da URL de confirmação
 */
export const parseScheduleConfirmationUrl = (url: string) => {
  try {
    const parts = url.split('/');
    const scheduleId = parts[parts.length - 2];
    const token = parts[parts.length - 1];
    return { scheduleId, token };
  } catch {
    return null;
  }
};

/**
 * Valida se o URL é uma URL de confirmação de agendamento válida
 */
export const isValidScheduleConfirmationUrl = (url: string): boolean => {
  const pattern = /\/confirm-appointment\/[^/]+\/[^/]+$/;
  return pattern.test(url);
};
